import { Dialog } from '@headlessui/react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Modal } from '../../../components/modal/Modal';
import { Button } from '../../../components/buttons/Button';

export const ModalDeleteStudentNote = ({
	open,
	onClose,
	onConfirm,
	loading = false,
	noteTitle,
	cancelButtonRef,
}) => {
	return (
		<Modal
			open={open}
			setOpen={(nextOpen) => {
				if (!nextOpen) onClose?.();
			}}
			cancelButtonRef={cancelButtonRef}
			autoCloseModal={false}
		>
			<div className="bg-white rounded-lg overflow-hidden">
				<div className="px-6 py-5 border-b border-gray-200">
					<div className="flex items-start gap-4">
						<div className="w-12 h-12 rounded-full flex items-center justify-center bg-rose-500/15 border-2 border-rose-500/30">
							<ExclamationTriangleIcon className="w-6 h-6 text-rose-600" aria-hidden />
						</div>
						<div className="min-w-0">
							<Dialog.Title as="h3" className="text-xl font-bold text-gray-900">
								Eliminar nota
							</Dialog.Title>
							<p className="mt-1 text-sm text-gray-600">
								Esta acción no se puede deshacer.
							</p>
						</div>
					</div>
				</div>

				<div className="px-6 py-5">
					<p className="text-sm text-gray-700">
						Confirmas que deseas eliminar la nota{' '}
						<span className="font-semibold text-gray-900">{noteTitle || 'sin título'}</span>?
					</p>
				</div>

				<div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
					<div className="flex flex-col-reverse sm:flex-row gap-3">
						<Button
							type="button"
							variant="secondary"
							className="flex-1 sm:flex-initial border border-gray-300 shadow-sm"
							disabled={loading}
							onClick={onClose}
							ref={cancelButtonRef}
						>
							Cancelar
						</Button>
						<Button
							type="button"
							variant="dangerGradient"
							className="flex-1 py-2.5 px-6"
							loading={loading}
							loadingLabel="Eliminando..."
							disabled={loading}
							onClick={onConfirm}
						>
							Eliminar nota
						</Button>
					</div>
				</div>
			</div>
		</Modal>
	);
};
